<template>
  <div class="house-card" @click="detail">
    <div class="img">
      <img :src="item.fileImg" alt="封面" />
      <img v-if="item.panorama" src="https://static.ajl.cn/web/360.png" alt="全景图标" class="panorama" />
    </div>
    <div class="area">
      <span class="area-label">{{ $cov(item.area || item.roomArea || item.buildArea).num }}</span>
      <span class="area-unit">㎡</span>
    </div>
    <div class="price" v-if="tradeType * 1 === 1">
      <span v-if="priceType === 1">{{ parseFloat(item.area) > 0 ? parseFloat((parseFloat(item.consultPrice) / parseFloat(item.area)).toFixed(2)) : 0 }}</span>
      <span v-if="priceType === 1" class="price-unit">元/月/㎡</span>
      <span v-if="priceType === 2">{{ $cov(item.consultPrice).num }}</span>
      <span v-if="priceType === 2" class="price-unit">{{ $cov(item.consultPrice).unit }}</span>
    </div>
    <div class="price" v-if="tradeType * 1 === 2">
      <span v-if="priceType === 1">{{ parseFloat(item.area) > 0 ? parseFloat(((parseFloat(item.consultPrice) * 10000) / parseFloat(item.area)).toFixed(2)) : 0 }}</span>
      <span v-if="priceType === 1" class="price-unit">元/㎡</span>
      <span v-if="priceType === 2">{{ $cov(item.consultPrice).num }}</span>
      <span v-if="priceType === 2" class="price-unit">{{ $cov(item.consultPrice).unit }}</span>
    </div>
    <template v-if="!tradeType"> khoihj </template>
    <div class="orientation">{{ item.orientationName }}</div>
    <div class="update">{{ item.releaseTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'house-card',
  props: { item: Object, priceType: Number, tradeType: String },
  methods: {
    detail() {
      this.$router.push({ name: this.root.name + '.first-detail', query: { id: this.item.id, from: this.$route.query.from } });
    },
  },
};
</script>

<style lang="scss" scoped>
.house-card {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 10px 0;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
  .img {
    height: 60px;
    position: relative;
    img {
      width: 96px;
      height: 100%;
      border-radius: 6px;
      margin: 0 auto;
    }
    .panorama {
      width: 15px;
      height: 15px;
      position: absolute;
      left: 25px;
      bottom: 5px;
      animation-name: ani;
      animation-duration: 2.6s;
      animation-iteration-count: infinite;
    }
  }
  .area {
    display: flex;
    align-items: center;
    justify-content: center;
    &-label {
      font-size: 20px;
      margin-right: 4px;
    }
    &-unit {
      font-size: 12px;
    }
  }
  .price {
    font-size: 20px;
    color: #cc2929;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: block;
    }
    &-unit {
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .person {
    font-size: 20px;
    color: #000;
  }
  .orientation {
    font-size: 12px;
    color: #000;
  }
  .update {
    font-size: 12px;
    color: #b2b2b2;
  }
}
@keyframes ani {
  70% {
    transform: rotate(360deg) scale(1.2);
  }
  100% {
    transform: rotate(360deg) scale(1.2);
  }
}
</style>
